<template>
    <v-container fluid class="fill-height">
      <v-row align="center" justify="center" >
        <v-col cols="12" sm="9" md="7" lg="5">
  <card v-if="complete"
    ref="complete-form"
    class="pb-1"
    title="Complete register"
    form-id="complete-form"
    main-action="submitForm,complete-form"
    form-action="/complete-register"
    main-action-text="Complete"
    :error-message="errorMessage"
  >
<template v-slot:form-fields>
        <v-row wrap no-gutters>
          <v-col cols="12" sm="6" class="pr-sm-2">
            <v-text-field
                name="firstname"
                :label="$tf('Firstname')+ ' *'"
                v-model="firstname"
                :rules="validationFormRule('firstname')"
            >
              <span slot="label">
                {{$tf('Firstname')}}<span class="mandatory">*</span>
              </span>
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
                name="lastname"
                :label="$tf('Lastname')+ ' *'"
                v-model="lastname"
                :rules="validationFormRule('lastname')"
            >
              <span slot="label">
                {{$tf('Lastname')}}<span class="mandatory">*</span>
              </span>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
                name="email"
                v-model="email"
                ref="email"
                id="email"
                type="email"
                :readonly="!$allowSelfRegistration && $oidcRegistrationMode === 'only_oidc_email'"
                :rules="validationFormRule('email')"
            >
              <span slot="label">
                {{$tf('Email')}}<span class="mandatory">*</span>
              </span>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
                name="promoCode"
                v-model="promoCode"
                ref="promoCode"
                id="promoCode">
              <span slot="label">
                {{$tf('Promotional code')}} ({{$tf('Optional')}})
              </span>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-checkbox
                  v-on="on"
                  name="advanced_user"
                  v-model="advancedUser"
                  ref="advancedUser"
                  id="advancedUser"
                  :value="advancedUser">
                       <span  v-on="on" slot="label">
                        {{$tf('I am an advanced user')}}
                      </span>
                </v-checkbox>
              </template>
              <span>{{$tf('AdvancedUserTooltip')}}</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div id="terms">
              <v-checkbox
                  v-model="terms"
                  :rules="validationFormRule('terms')"
                  ref="terms"
                  name="terms"
                  :value="terms"
              >
                <span slot="label">
                  {{$tf('I accept')}}
                  <a href="#"
                     @click.prevent.stop="showIt('terms')">
                    {{$tf('the Terms and Conditions')}}
                  </a>
                  <span class="mandatory">*</span>
                </span>
              </v-checkbox>
              <v-checkbox
                  v-model="privacy"
                  :rules="validationFormRule('terms')"
                  ref="privacy"
                  name="privacy"
                  :value="privacy"
              >
                <span slot="label">
                  {{$tf('I accept')}}
                  <a href="#"
                    @click.prevent.stop="showIt('privacy')">
                    {{$tf('the Privacy Policy')}}
                  </a>
                  <span class="mandatory">*</span>
                </span>
              </v-checkbox>
              <v-checkbox
                  name="commercial"
                  v-model="commercial"
                  :value="commercial"
              >
                <span slot="label">
                    {{$tf('I accept')}} {{$tf('receiving commercial communications')}}
                </span>
              </v-checkbox>
            </div>
          </v-col>
        </v-row>
        <input type="hidden"
               :value="locale"
               name="hl"
        >
</template>
    <template v-slot:extra v-if="accessMethods.filter(method => method.type !== 'password').length > 0 && !complete">
      <v-divider class="my-2" v-if="canAccess('password')"/>
      <v-card-text v-if="canAccess('password')">
        <span >{{$vuetify.breakpoint.xs?$tf('You also can') + ' ' + $tf('Continue with'): $tf('You also can')}}</span>
      </v-card-text>
      <v-card-text v-else-if="$vuetify.breakpoint.xs">
        <span>{{$tf('Continue with')}}</span>
      </v-card-text>
      <v-card-actions>
        <button-list
          :methods="accessMethods"
          :label="$tf('Continue with')"></button-list>
      </v-card-actions>
    </template>
  </card>
  <card v-else
                ref="register-form"
                class="pb-1"
                title="SignUp"
                :form-id="canAccess('password')?'register-form':''"
                :main-action="canAccess('password')?'submitForm,register-form':''"
                form-action="/register"
                main-action-text="SignUp"
                :secondary-action="'goTo,login.html,&email=' + encodeURIComponent(email) +
                 buildWLParam($wlDomain) +
                 '&access_methods=' + urlStringMethods() "
                secondary-action-text="I have an account"
                :error-message="errorMessage"
          >
            <template v-slot:form-fields>
              <input type="hidden"
                     :value="getPassword()"
                     name="password"
              >
              <v-row wrap no-gutters>
                <v-col cols="12" sm="6" class="pr-sm-2 py-xs-1 py-sm-1">
                  <v-text-field
                    name="firstname"
                    :label="$tf('Firstname')+ ' *'"
                    v-model="firstname"
                    :rules="validationFormRule('firstname')"
                  >
              <span slot="label">
                {{$tf('Firstname')}}<span class="mandatory">*</span>
              </span>
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" class="py-xs-1 py-sm-1">
                  <v-text-field
                    name="lastname"
                    :label="$tf('Lastname')+ ' *'"
                    v-model="lastname"
                    :rules="validationFormRule('lastname')"
                  >
              <span slot="label">
                {{$tf('Lastname')}}<span class="mandatory">*</span>
              </span>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col class="py-1">
                  <v-text-field
                    name="email"
                    v-model="email"
                    ref="email"
                    id="email"
                    type="email"
                    :rules="validationFormRule('email')"
                  >
              <span slot="label">
                {{$tf('Email')}}<span class="mandatory">*</span>
              </span>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-1">
                  <v-text-field
                    name=""
                    v-model="password"
                    ref="password"
                    :append-icon="visiblePassword ? 'visibility_off' : 'visibility'"
                    @click:append="() => (visiblePassword = !visiblePassword)"
                    :type="visiblePassword ? 'text' : 'password'"
                    :rules="validationFormRule('password')"
                  >
              <span slot="label">
                {{$tf('Password')}}<span class="mandatory">*</span>
              </span>
                    <span v-if="capsLock" slot="append-outer">
                          <caps-lock-warning></caps-lock-warning>
                    </span>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row class="py-0">
                <v-col class="py-1">
                  <v-text-field
                    name=""
                    v-model="repeatPassword"
                    ref="repeatPassword"
                    :append-icon="visiblePassword ? 'visibility_off' : 'visibility'"
                    @click:append="() => (visiblePassword = !visiblePassword)"
                    :type="visiblePassword ? 'text' : 'password'"
                    :rules="validationFormRule('repeatPassword')"
                  >
              <span slot="label">
                {{$tf('Repeat Password')}}<span class="mandatory">*</span>
              </span>
                    <span v-if="capsLock" slot="append-outer">
                          <caps-lock-warning></caps-lock-warning>
                    </span>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-1">
                  <v-text-field
                    name="promo_code"
                    v-model="promoCode"
                    ref="promoCode"
                    id="promoCode">
              <span slot="label">
                {{$tf('Promotional code')}} ({{$tf('Optional')}})
              </span>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-1">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-checkbox
                        v-on="on"
                        name="advanced_user"
                        v-model="advancedUser"
                        ref="advancedUser"
                        id="advancedUser"
                        :value="advancedUser">
                 <span  v-on="on" slot="label">
                  {{$tf('I am an advanced user')}}
                </span>
                      </v-checkbox>
                    </template>
                    <span>{{$tf('AdvancedUserTooltip')}}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-row class="py-0">
                <v-col class="py-0">
                  <div id="politica">
                    <v-checkbox
                      v-model="terms"
                      :rules="validationFormRule('terms')"
                      ref="terms"
                      name="terms"
                      :value="terms"
                    >
                <span slot="label">
                  {{$tf('I accept')}}
                  <a href="#"
                     @click.prevent.stop="showIt('terms')">
                    {{$tf('the Terms and Conditions')}}
                  </a>
                  <span class="mandatory">*</span>
                </span>
                    </v-checkbox>
                    <v-checkbox
                      v-model="privacy"
                      :rules="validationFormRule('terms')"
                      ref="privacy"
                      name="privacy"
                      :value="privacy"
                    >
                <span slot="label">
                  {{$tf('I accept')}}
                  <a href="#"
                     @click.prevent.stop="showIt('privacy')">
                    {{$tf('the Privacy Policy')}}
                  </a>
                  <span class="mandatory">*</span>
                </span>
                    </v-checkbox>
                    <v-checkbox
                      name="commercial"
                      v-model="commercial"
                      :value="commercial"
                    >
                <span slot="label">
                    {{$tf('I accept')}} {{$tf('receiving commercial communications')}}
                </span>
                    </v-checkbox>
                  </div>
                </v-col>
              </v-row>
              <v-row v-if="isCaptchaRendered">
                <v-col>
                  <p v-if="recaptchaError" class="error--text">{{$tf('Please check this box to prove that you are human')}}</p>
                  <div id="recaptcha"></div>
                </v-col>
              </v-row>
              <v-text-field v-if="isCaptchaRendered"
                v-show="false"
                :value="recaptchaResponse"
                name="g-recaptcha-response"
                :rules="[v => !!v]"
              />
            </template>
    <template v-slot:extra>
      <div v-if="accessMethods.filter(method => method.type !== 'password').length > 0">
        <v-divider class="my-2" v-if="canAccess('password')"/>
        <v-card-text v-if="canAccess('password')" >
          <span>{{$vuetify.breakpoint.xs?$tf('You also can') + ' ' + $tf('Sign in with'): $tf('You also can')}}</span>
        </v-card-text>
        <v-card-text v-else-if="$vuetify.breakpoint.xs">
          <span>{{$tf('Sign in with')}}</span>
        </v-card-text>
        <v-card-actions>
          <button-list :methods="accessMethods" :label="$tf('Sign in with')"></button-list>
        </v-card-actions>
      </div>
    </template>
          </card>
  <v-dialog v-model="showDialog" max-width="800px" :fullscreen="$vuetify.breakpoint.xs">
    <terms v-if="dialog==='terms'"></terms>
    <policy v-if="dialog==='privacy'"></policy>
  </v-dialog>
  <idp-footer></idp-footer>
     </v-col>
  </v-row>
  </v-container>
</template>

<script>
import register from '@/mixins/register'
import access from '@/mixins/access'
import recaptcha from '@/mixins/recaptcha'
import Terms from './dialogs/Terms'
import Policy from './dialogs/Policy'
import idpFooter from './footer/Footer'
import Card from './templates/Card'
import ButtonList from './templates/ButtonList'
import CapsLockWarning from './CapsLockWarning'
import { buildWLParam } from '@/commons/whitelabel'
export default {
  name: 'register-form',
  components: { CapsLockWarning, Card, idpFooter, Policy, Terms, ButtonList },
  mixins: [access, register, recaptcha],
  data () {
    return {
      captchaAction: 'register'
    }
  },
  methods: {
    buildWLParam
  }
}
</script>

<style lang="scss" scoped>

  .mandatory {
    padding-left: 5px;
    color: red;
  }

</style>
